module.exports = __webpack_public_path__ + "static/2-352c38776de3644504668309dbe4db42.jpg";